import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Heart } from "lucide-react";
import { EggmanLogo } from "./EggmanLogo";

export default function Footer() {
  return (
    <footer className="bg-[#0E2818] text-stone-200 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <EggmanLogo className="h-16" />
          <p className="mt-5 text-stone-300 max-w-md leading-relaxed">
            We're the bridge between NZ farms and Kiwi families — delivering genuine farm-fresh eggs at
            a fair price across Auckland. More groceries coming soon.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#F4C430]">
            Fresh Eggs · Better Nutrition · Trusted Quality
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-widest text-xs text-[#EA580C] mb-4">Browse</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/products" className="hover:text-white transition-colors">Products</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/wholesale" className="hover:text-[#F4C430] transition-colors font-semibold">Wholesale</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Customer Login</Link></li>
            <li><Link to="/driver/login" className="hover:text-white transition-colors">Driver Portal</Link></li>
            <li><Link to="/admin/login" className="hover:text-white transition-colors">Admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-widest text-xs text-[#EA580C] mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><Phone size={16} className="mt-0.5 text-[#EA580C]" /> 022 373 4083</li>
            <li className="flex items-start gap-2.5"><Mail size={16} className="mt-0.5 text-[#EA580C]" /> <a href="mailto:hello@eggman.co.nz" className="hover:text-white transition-colors">hello@eggman.co.nz</a></li>
            <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 text-[#EA580C]" /> Auckland — more areas coming soon</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-6 flex flex-col items-center gap-2 text-center">
          <div className="font-display italic text-2xl text-[#F4C430] flex items-center gap-3" data-testid="footer-thanks">
            <Heart size={16} className="fill-[#F4C430] text-[#F4C430]" />
            Thank you for supporting local!
            <Heart size={16} className="fill-[#F4C430] text-[#F4C430]" />
          </div>
          <div className="flex flex-col md:flex-row justify-between gap-2 text-xs text-stone-400 w-full mt-3">
            <p>© {new Date().getFullYear()} EGGMAN Delivery. All prices exclude GST.</p>
            <p>Auckland — bulk orders available NZ-wide</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
